export const bigqueryLanguageDefinition = {
    aliases: ['BigQuery', 'bigquery'],
    extensions: [],
    id: 'bigquery',
    loader: () => import('./bigquery.js'),
};
//# sourceMappingURL=bigquery.contribution.js.map